module.exports = __webpack_public_path__ + "img/note.9927febf.svg";